var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1165_2012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7639 9.7886C17.2057 9.7886 17.5639 9.43043 17.5639 8.9886C17.5639 8.54677 17.2057 8.1886 16.7639 8.1886C16.322 8.1886 15.9639 8.54677 15.9639 8.9886C15.9639 9.43043 16.322 9.7886 16.7639 9.7886Z",
    fill: "#FF3C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7635 16.1887C14.5308 16.1887 15.9635 14.756 15.9635 12.9887C15.9635 11.2214 14.5308 9.7887 12.7635 9.7887C10.9962 9.7887 9.56348 11.2214 9.56348 12.9887C9.56348 14.756 10.9962 16.1887 12.7635 16.1887Z",
    fill: "#FF3C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5637 0.988647H5.96367C4.58455 0.988647 3.26191 1.5365 2.28672 2.51169C1.31153 3.48688 0.763672 4.80952 0.763672 6.18865L0.763672 19.7886C0.763672 20.4715 0.898174 21.1477 1.1595 21.7786C1.42082 22.4095 1.80385 22.9827 2.28672 23.4656C3.26191 24.4408 4.58455 24.9886 5.96367 24.9886H19.5637C20.2465 24.9886 20.9227 24.8541 21.5536 24.5928C22.1845 24.3315 22.7578 23.9485 23.2406 23.4656C23.7235 22.9827 24.1065 22.4095 24.3678 21.7786C24.6292 21.1477 24.7637 20.4715 24.7637 19.7886V6.18865C24.7637 5.50577 24.6292 4.82959 24.3678 4.19869C24.1065 3.5678 23.7235 2.99456 23.2406 2.51169C22.7578 2.02883 22.1845 1.6458 21.5536 1.38447C20.9227 1.12315 20.2465 0.988647 19.5637 0.988647V0.988647ZM19.9637 16.8886C19.9626 17.7635 19.6146 18.6023 18.996 19.2209C18.3773 19.8396 17.5386 20.1876 16.6637 20.1886H8.86367C7.98878 20.1876 7.15003 19.8396 6.53139 19.2209C5.91275 18.6023 5.56473 17.7635 5.56367 16.8886V9.08865C5.56473 8.21376 5.91275 7.375 6.53139 6.75636C7.15003 6.13772 7.98878 5.78971 8.86367 5.78865H16.6637C17.5386 5.78971 18.3773 6.13772 18.996 6.75636C19.6146 7.375 19.9626 8.21376 19.9637 9.08865V16.8886Z",
    fill: "#FF3C2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1165_2012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.763672 0.988647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIg);
export default __webpack_public_path__ + "static/media/social_ig.c5aa222574b719dea19ad52e9b9a1567.svg";
export { ForwardRef as ReactComponent };